import { CoaComponent } from "../components/coaComponent"

export const CoaPage = () => {
  document.title = "COA"
  return (<CoaComponent page="coa" />)
}